import React from 'react';
import Icon from './UIThemeControls';
import { useTheme } from "react-hook-theme";

import * as styles from './DarkModeToggle.module.scss';

const darkProgressIndicator = () => {
	var indicator = typeof document !== 'undefined' && document.getElementById('gatsby-plugin-page-progress');
	if (indicator) indicator.style.backgroundColor = '#6BCDB2';
};

const lightProgressIndicator = () => {
	var indicator = typeof document !== 'undefined' && document.getElementById('gatsby-plugin-page-progress');
	if (indicator) indicator.style.backgroundColor = '#e14524';
};

const DarkModeToggle = () => {
	const { theme, setTheme } = useTheme();

	const toggleTheme = (event, theme) => {
		if (event) {
			event.preventDefault();
		}
        if (event.type == 'keydown') {
            if (event.keyCode == 13) {
                setTheme(theme)
                var target = event.currentTarget.childNodes[0]
                if ( target.className.indexOf('sun_animated') > -1 ) {
                    target.className = 'moon_animated';
                } else {
                    target.className = 'sun_animated';
                }
                var embedClasses = [".twitter-tweet", ".twitter-timeline", ".twitter-follow-button", ".twitter-share-button"].join(",");
                if (document.querySelector(embedClasses) !== null) {
                    window.location.reload();
                }
            } else if(event.shiftKey && event.keyCode == 9) {
                document.getElementById('accessibilityWidgetHeader').focus();
            } else {
                document.getElementById('selectLangTop').focus();
            }
        } else {
            setTheme(theme)
            var target = event.currentTarget.childNodes[0]
            if ( target.className.indexOf('sun_animated') > -1 ) {
                target.className = 'moon_animated';
            } else {
                target.className = 'sun_animated';
            }
            var embedClasses = [".twitter-tweet", ".twitter-timeline", ".twitter-follow-button", ".twitter-share-button"].join(",");
            if (document.querySelector(embedClasses) !== null) {
                window.location.reload();
            }
        }
		
	};

	if (theme === 'dark') {
		typeof window !== 'undefined' && localStorage.setItem('progressBarColor', '#6BCDB2');
		darkProgressIndicator();
	} else {
		lightProgressIndicator();
		typeof document !== 'undefined' && localStorage.setItem('progressBarColor', '#e14524');
	}

	return (
		<li id='toggleTheme' className={styles.wrapper} tabIndex={0} onClick={e => toggleTheme(e, theme === 'light' ? 'dark' : 'light')} onKeyDown={e => toggleTheme(e, theme === 'light' ? 'dark' : 'light')}>
			<button id="mode" type="button">
				{theme === 'dark' ? <Icon type="sun" /> : <Icon type="moon" />}
			</button>
		</li>
	);
};

export default DarkModeToggle;